<template>
  <div class="flex flex-col justify-end items-center flex-grow text-white">
    <h1 class="font-serif text-6xl md:text-7xl text-center mb-5 drop-shadow-3xl tracking-wider">Maria Gruber</h1>
    <p class="mb-6 font-sans text-3xl md:text-4xl text-center drop-shadow-3xl tracking-wider uppercase">Actress / Voice Actress</p>
    <div class="w-full flex justify-center">
      <!--
          The accessible name lives on the button, so the icon itself is marked
          decorative (alt="") - otherwise screen readers announce the control
          twice.
      -->
      <button
        type="button"
        class="cursor-pointer flex-shrink"
        @click="scrollDown"
        aria-label="Scroll to the demos"
      >
        <img
          class="drop-shadow-3xl w-20 h-20"
          src="../assets/icons/arrow_down.svg"
          alt=""
        >
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  methods: {
    scrollDown() {
      const workSection = document.querySelector('#work');
      workSection.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  },
}
</script>

<style scoped>
/*  .text-shadow {
    text-4
  }*/
</style>
